module.exports = __webpack_public_path__ + "static/media/pexels-photo-1166643.6873a811.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/pexels-photo-1166643.jpeg
// module id = 112
// module chunks = 0